var StateDetector = new function () {
  this.indicator = ".mediaquery-indicator";
  this.init = function () {
    StateDetector.indicator = ".mediaquery-indicator";
    StateDetector.currentState = StateDetector.getDeviceState();
    StateDetector.stateDetectorId = 0;
    StateDetector.timeOut = 100;
    $(window).on("resize", function () {
      $("body").trigger("resizing");
      clearTimeout(StateDetector.stateDetectorId);
      StateDetector.stateDetectorId = setTimeout(StateDetector.triggerResizing, StateDetector.timeOut);
    });
  };
  this.getDeviceState = function () {
    var index = parseInt($(StateDetector.indicator).css('z-index'));
    var states = this.getStates();
    if (states[index] != undefined) {
      return states[index];
    } else {
      if (console) {
        console.error('The z-index in class "' + StateDetector.indicator + '" has been altered. The index provided is "' + index + '". Please, do not override this CSS class. ');
      }
    }
  };
  this.triggerResizing = function () {
    $("body").trigger("resizing_done", [StateDetector.getDeviceState()]);
    var newState = StateDetector.getDeviceState();
    if (newState != StateDetector.currentState) {
      StateDetector.currentState = newState;
      $("body").trigger("device_state_changed", [StateDetector.getDeviceState()]);
    }
  };
  this.getStates = function () {
    var states = {
      3: 'small-desktop',
      2: 'tablet',
      1: 'phone'
    };
    return states;
  };
  this.PHONE = function () {
    return this.getStates()[1];
  };
  this.TABLET = function () {
    return this.getStates()[2];
  };
  this.SMALL_DESKTOP = function () {
    return this.getStates()[3];
  };
}();